import styled from "styled-components";
import {HistoryRecordHeaderDefaultBox} from "./history-record-header.default.box";

export const HistoryRecordHeaderSiCisBox = styled(HistoryRecordHeaderDefaultBox)`
    border-bottom: none;
`;